import envPublic from '@/config/env.public';

export function createBrandsUrl() {
  return '/brands';
}

export function createBrandUrl(query: string) {
  return `/brands/${query}`;
}

export function createCountyOfOriginUrl(query: string) {
  return `/country/${query}`;
}

export function createHasBidUrl() {
  return `/search?hasBid=true&page=1`;
}

export function createHasAskUrl() {
  return `/search?hasAsk=true&page=1`;
}

export function createSortByUrl(query: string) {
  return `/search?sortBy=${query}&page=1`;
}

export function createMostPopularTopicUrl() {
  return `/search?sortBy=${envPublic.NEXT_PUBLIC_ALGOLIA_REPLICA_BY_MOST_POPULAR}&page=1`;
}

export function createMostWatchedTopicUrl() {
  return `/search?sortBy=${envPublic.NEXT_PUBLIC_ALGOLIA_REPLICA_BY_WATCHED}&page=1`;
}

export function createNewestTopicUrl() {
  return `/search?sortBy=${envPublic.NEXT_PUBLIC_ALGOLIA_REPLICA_BY_NEW}&page=1`;
}

export function createReleaseCalendarTopicUrl() {
  const replica = envPublic.NEXT_PUBLIC_ALGOLIA_REPLICA_BY_RELEASE_CALENDAR;
  const filter = encodeURIComponent('isUpcoming=1');
  return `/search?sortBy=${replica}&filters=${filter}&page=1`;
}

export function createLowestAskTopicUrl() {
  return `/search?sortBy=${envPublic.NEXT_PUBLIC_ALGOLIA_REPLICA_LOWEST_ASK_ASC}&page=1`;
}

export function createHighestBidTopicUrl() {
  return `/search?sortBy=${envPublic.NEXT_PUBLIC_ALGOLIA_REPLICA_HIGHEST_BID_DESC}&page=1`;
}

export function createAlphabeticalTopicUrl() {
  return `/search?sortBy=${envPublic.NEXT_PUBLIC_ALGOLIA_REPLICA_ALPHABET_ASC}&page=1`;
}

export function createCategoryUrl(query: string) {
  return `/category/${query}`;
}

export function createSearchUrl(query: string) {
  return `/search?search=${query}&page=1`;
}

export function createFooterSkuUrl(category: string, country: string) {
  return `/category/${category}?brand.countryOfOrigin=${country}&page=1`;
}
